<template>
  <div class="header-wrapper">
    <header class="app-header">
      <div class="header-container">
        <!-- 左侧 Logo -->
        <router-link to="/"
                     class="logo">
          <img src="@/assets/logo.png"
               :alt="$t('common.logoAlt')"
               class="logo-img" />

        </router-link>

        <!-- 右侧 导航 -->
        <nav class="nav-menu">
          <div v-for="(item, index) in menuItems"
               :key="index"
               class="nav-item"
               @mouseenter="handleMouseEnter(index)"
               @mouseleave="handleMouseLeave">
            <router-link :to="item.path"
                         class="nav-link"
                         :class="{ 'active': $route.path === item.path || activeIndex === index }">
              {{ $t(item.labelKey) }}
            </router-link>

            <!-- 普通下拉菜单 (仅当不是 Mega Menu 时渲染在 Item 内部) -->
            <transition name="dropdown">
              <div v-if="activeIndex === index && !item.megaMenu && item.children && item.children.length > 0"
                   class="dropdown-menu">
                <router-link v-for="(subItem, subIndex) in item.children"
                             :key="subIndex"
                             :to="subItem.path || '/'"
                             class="dropdown-item">
                  {{ $t(subItem.labelKey) }}
                </router-link>
              </div>
            </transition>
          </div>
          <LanguageSwitcher class="header-lang-switch" />
        </nav>
      </div>

      <!-- Mega Menu (独立容器，相对于 Header 定位) -->
      <transition name="mega-fade">
        <div v-if="activeMegaMenuItem"
             class="mega-menu-wrapper"
             @mouseenter="handleMegaEnter"
             @mouseleave="handleMegaLeave">
          <div class="mega-content">
            <div v-for="(col, colIndex) in activeMegaMenuItem.columns"
                 :key="colIndex"
                 class="mega-column">
              <h3 class="mega-title">{{ $t(col.titleKey) }}</h3>
              <p class="mega-subtitle"
                 v-if="col.subtitle">{{ $t(col.subtitle) }}</p>
              <div class="mega-items">
                <router-link v-for="(subItem, subIndex) in col.items"
                             :key="subIndex"
                             :to="subItem.link || '/'"
                             class="mega-item">

                  <span class="mega-item-text">{{ $t(subItem.nameKey) }}</span>
                  <span class="mega-item-arrow">»</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </header>
  </div>
</template>

<script>
import LanguageSwitcher from './LanguageSwitcher.vue'

export default {
  name: 'AppHeader',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      activeIndex: null,
      hoverTimer: null,
      menuItems: [
        { labelKey: 'nav.home', path: '/' },
        {
          labelKey: 'nav.products',
          path: '/products',
          megaMenu: true,
          columns: [
            {
              titleKey: 'nav.device',
              items: [
                {
                  nameKey: 'product.light530.name',
                  link: '/product/light530'
                },
                {
                  nameKey: 'product.light640.name',
                  link: '/product/light640'
                },
                {
                  nameKey: 'product.lightbule530.name',
                  link: '/product/blue530'
                },
                {
                  nameKey: 'product.lightm20.name',
                  link: '/product/m20'
                },
              ]
            },
            {
              titleKey: 'nav.kits',
              items: [
                {
                  nameKey: 'nav.kitsSystem',
                  link: '/product/kits'
                },
                {
                  nameKey: 'nav.kitsAccessories',
                  link: '/product/kits-accessories'
                }
              ]
            },
            {
              titleKey: 'nav.courses',
              items: [
                {
                  nameKey: 'nav.courses',
                  link: '/product/courses'
                }
              ]
            },
            {
              titleKey: 'nav.accessories',
              items: [
                {
                  nameKey: 'nav.accessories',
                  link: '/product/accessories'
                }
              ]
            }
          ]
        },
        {
          labelKey: 'nav.software',
          path: '/software',
          children: [
            { labelKey: 'nav.learningPlatform', path: '/software/learning-platform' },
            { labelKey: 'nav.cloudPlatform', path: '/software/cloud-platform' },
            { labelKey: 'nav.laserSoftware', path: '/software/laser-software' }
          ]
        },
        {
          labelKey: 'nav.eduServices',
          path: '/edu-services',
          children: [
            { labelKey: 'nav.makerK12', path: '/edu-services/maker-k12' },
            { labelKey: 'nav.archVocational', path: '/edu-services/architectural-vocational' },
            { labelKey: 'nav.cultHigherVoc', path: '/edu-services/cultural-higher-vocational' },
            { labelKey: 'nav.artsUni', path: '/edu-services/arts-university' }
          ]
        },
        {
          labelKey: 'nav.support',
          path: '/support',
          children: [
            { labelKey: 'nav.afterSales', path: '/support/after-sales' },
            { labelKey: 'nav.download', path: '/support/download' }
          ]
        },
        {
          labelKey: 'nav.cooperation',
          path: '/edu-services/cooperation',
          children: [

          ]
        },
        {
          labelKey: 'nav.about',
          path: '/about',
          children: [
            { labelKey: 'nav.companyIntro', path: '/about' },
            { labelKey: 'nav.news', path: '/about/news' }
          ]
        }
      ]
    }
  },
  computed: {
    activeMegaMenuItem() {
      if (this.activeIndex !== null && this.menuItems[this.activeIndex] && this.menuItems[this.activeIndex].megaMenu) {
        return this.menuItems[this.activeIndex]
      }
      return null
    }
  },
  methods: {
    handleMouseEnter(index) {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      this.activeIndex = index
    },
    handleMouseLeave() {
      // 延迟隐藏，给鼠标移动到 Mega Menu 的时间
      this.hoverTimer = setTimeout(() => {
        this.activeIndex = null
      }, 200)
    },
    handleMegaEnter() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
    },
    handleMegaLeave() {
      this.hoverTimer = setTimeout(() => {
        this.activeIndex = null
      }, 200)
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  height: 70px; /* 占位高度，防止内容被遮挡 */
}

.app-header {
  width: 100%;
  height: 70px;
  background-color: #2ea2fa;

  position: fixed; /* 固定定位 */
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-container {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo 区域 */
.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #fff;
}

.logo-img {
  height: 40px;
  margin-right: 12px;
  /* 如果实际 Logo 不需要反白，这里不需要 filter。
     Vue Logo 是绿色的，这里为了配合蓝底可能需要调整，
     但用户给的参考图是有特定 Logo 的。暂时保持原样。 */
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #fff;
}

/* 导航菜单 */
.nav-menu {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 50px; /* 间距 50px */
  cursor: pointer;
}

/* 第一个项去掉左边距，或者保持统一 */
.nav-item:first-child {
  margin-left: 0;
}

.nav-link {
  font-size: 18px;
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.3s;
  /* 增加点击区域高度 */
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 5px; /* 稍微加点水平内边距 */
  position: relative;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  opacity: 1; /* 保持高亮 */
}

/* 简单的下划线动效 */
.nav-link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #fff;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.nav-link:hover::after,
.nav-item:hover .nav-link::after {
  transform: scaleX(1);
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  top: 70px; /* Header 高度 */
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  min-width: 160px;

  border-radius: 0 0 4px 4px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
}

.dropdown-item {
  padding: 10px 20px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.2s, color 0.2s;
  text-align: center;
  white-space: nowrap;
}

.dropdown-item:hover {
  background-color: #f0f8ff;
  color: #2ea2fa;
}

/* 动画效果：丝滑流程 */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top center;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px) scaleY(0.9);
}

.dropdown-enter-to,
.dropdown-leave {
  opacity: 1;
  transform: translateX(-50%) translateY(0) scaleY(1);
}

/* Mega Menu Styles (New) */
.mega-menu-wrapper {
  position: absolute; /* 相对于 Header */
  top: 100%; /* 紧贴 Header 底部 */
  left: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px 0;
  z-index: 999;
}

/* Mega Menu 动画 */
.mega-fade-enter-active,
.mega-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.mega-fade-enter,
.mega-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mega-content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start; /* 左对齐 */
}

.mega-column {
  flex: 1; /* 每列等宽，或者根据内容 */
  max-width: 300px; /* 限制每列最大宽度 */
  padding: 0 20px;
  border-right: 1px solid #eee;
}

.mega-column:last-child {
  border-right: none;
}

.mega-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 5px 0;
}

.mega-subtitle {
  font-size: 14px;
  color: #999;
  margin: 0 0 20px 0;
}

.mega-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mega-item {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  padding: 8px 0;
  transition: color 0.3s;
}

.mega-item:hover {
  color: #2ea2fa;
}

.mega-item-text {
  font-size: 16px;
  font-weight: 500;
  flex: 1;
}

.mega-item-arrow {
  font-size: 18px;
  margin-left: 10px;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
}

.mega-item:hover .mega-item-arrow {
  opacity: 1;
  transform: translateX(5px);
}

.header-lang-switch {
  margin-left: 50px;
}
</style>
